<template>
	<router-link
		tag="li"
		:to="productPath"
		:class="['product-list-variant-item dropdown-item', {'selected': selected}]"
	>
		<div class="variant-product-wrap">
			<ximg class="product-thumb" :src="src" :ariaLabel="product.name" role="img" />
			<span clasS="small">
				{{ productName }}
			</span>
			<product-price class="variant-item-price" :product="product" />
			<div :class="['stock-icon', stockClass]" :title="stockText" />
		</div>
		<hr class="_strong" />
	</router-link>
</template>

<script>
import { inStockAnywhere, urlFormat, daysBetweenDates, releaseToString, isProductReleased } from 'utils';
import router from 'router';
import store from 'datastore';
import { mapState } from 'vuex';
import { t } from 'datastore/i18n';

export default {
	store,
	props: ['product', 'selected'],
	data () {
		return {
			energyMarkingModal: false,
		};
	},
	methods: {
		t,
		tp: t.prefix('PRODUCT'),
	},
	computed: {
		productName () {
			return this.product.variantName ? this.product.variantName : this.product.name;
		},
		inStock () {
			return inStockAnywhere(this.product.stock);
		},
		stockClass () {
			if (! this.isReleased) {
				return 'stock-icon-notreleased';
			}
			else {
				if (this.inStock) {
					return 'stock-icon-instock';
				}
				else {
					return 'stock-icon-outofstock';
				}
			}
		},
		stockText () { // @TODO translate
			if (! this.isReleased) {
				return this.releaseDate;
			}
			else {
				if (this.inStock) {
					return 'I lager';
				}
				else {
					return 'Ej i lager';
				}
			}
		},
		src () {
			return '/images/product/' + this.product.id + '?trim&h=80';
		},
		daysUntilRelease () {
			const date = new Date();
			date.setTime(this.product.release.timestamp * 1000);
			const now = new Date();
			return daysBetweenDates(date, now);
		},
		productPath () {
			const name = this.product.variantName ? this.product.variantName : this.product.name;
			return router.route({
				name: 'product',
				params: {
					id: this.product.id,
					name: urlFormat(name),
				},
			});
		},
		isDiscount () {
			return this.product.regularPrice && this.product.price.price < this.product.regularPrice.price;
		},
		isReleased () {
			if (! this.product.release) {
				return true; // @TODO dubbelkolla
			}
			return isProductReleased(this.product.release);
		},
		releaseDate () {
			if (! this.product.release) {
				return '';
			}

			return releaseToString(this.product.release);
		},
		priceClasses () {
			return {
				'_campaign': this.isDiscount,
				'price-value': true,
			};
		},
		href () {
			return router.route({
				name: 'product',
				params: {
					id: this.product.id,
					name: urlFormat(this.product.name),
				},
			});
		},
		...mapState({
			user: state => state.user,
			userSettings: state => state.userSettings,
		}),
	},
};
</script>
